import {
  canAccessMemberModule,
  isInvestorPath,
  isStaffUserType,
  normalizeUserType,
} from "./investorAccess";
import { withInvestorQuery } from "./investorRouteHelpers";
import { resolveStaffHomePath } from "./staffRoleModules";

function isSafeRedirect(path) {
  if (!path || typeof path !== "string") return false;
  const normalized = path.trim().replace(/\/$/, "") || "/";
  if (normalized.startsWith("//") || normalized.includes("://")) return false;
  return normalized.startsWith("/");
}

/**
 * Whether the authenticated user may open the post-login redirect target.
 */
export function canAccessRedirectPath(userType, redirectPath) {
  if (!isSafeRedirect(redirectPath)) return false;

  const type = normalizeUserType(userType);

  if (isInvestorPath(redirectPath)) {
    return type === "investor" || type === "member";
  }

  if (redirectPath.startsWith("/member/") || redirectPath === "/member-signup") {
    return type === "member";
  }

  if (redirectPath.startsWith("/super_admin/")) {
    return isStaffUserType(userType);
  }

  return true;
}

/**
 * Post-login destination for cooperative API auth (staff, member, future investor).
 */
export function resolvePostCoopLoginPath(userType, queryParams = {}, staffProfile = null) {
  const { redirect, intent, itemId, tab, filter } = queryParams;

  if (redirect && canAccessRedirectPath(userType, redirect)) {
    return withInvestorQuery(redirect, { intent, itemId, tab, filter });
  }

  const type = normalizeUserType(userType);

  if (type === "investor") {
    return "/invest/dashboard";
  }

  if (canAccessMemberModule(userType)) {
    return "/member/dashboard";
  }

  if (isStaffUserType(userType)) {
    return resolveStaffHomePath(staffProfile?.role || null);
  }

  return "/login";
}

/**
 * Unified post-login routing for cooperative API user types.
 */
export function resolveUnifiedPostLoginPath({
  userType,
  queryParams = {},
  staffProfile = null,
} = {}) {
  return resolvePostCoopLoginPath(userType, queryParams, staffProfile);
}
